import { Box, Text, useColorModeValue, VStack } from '@chakra-ui/react';
import { IRegistrationsProps } from '../../../../services/hooks/CandidateArea/useRequestMyRegistration';
import LabelWithValueMobilePage from '../../../../components/Mobile/labelWithValue';
import { badgeColor } from '../../../../utils/badgeFunction';
import ActionList from '../HistoryRegistration/ActionList';
import RegistrationStatusBadge from '../HistoryRegistration/RegistrationStatusBadge';

interface IOwnProps {
  registration: IRegistrationsProps;
  isCultureHouse?: boolean;
  selectiveProcessId: string;
  isLegacy?: boolean;
  allowFilterVacancyTree?: boolean;
}

const CardRegistrationMobilePage: React.FC<IOwnProps> = ({
  registration,
  selectiveProcessId,
  isLegacy,
  isCultureHouse,
  allowFilterVacancyTree,
}) => {
  const cardBg = useColorModeValue('white', 'gray.700');
  const statusColor = badgeColor(registration?.status);

  return (
    <Box px={4} py={3} bg={cardBg} borderRadius="md" shadow="lg" w="100%">
      <VStack alignItems="initial" spacing={1} mb={2}>
        <LabelWithValueMobilePage label="Inscrição" value={registration?.registration_code?.toString()} />
        <LabelWithValueMobilePage
          label={isCultureHouse ? `Turma ${(registration?.second_vacancy && ' - primeira opção') || ''}` : 'Vaga/cargo'}
          value={registration?.vacancy_name}
        />
        {registration?.second_vacancy && (
          <LabelWithValueMobilePage label="Turma - segunda opção" value={registration?.second_vacancy} />
        )}
        <LabelWithValueMobilePage label="Data de inscrição" value={registration?.registration_date} />
        <Text fontWeight="bold">
          Situação:
          <RegistrationStatusBadge
            registrationId={registration.registration_id}
            status={registration.status}
            allowFilterVacancyTree={allowFilterVacancyTree}
            ml={2}
            w="fit-content"
            fontSize="x-small"
            px={2}
            bgColor={statusColor?.bgColor}
            color={statusColor?.color}
          />
        </Text>
      </VStack>
      <ActionList
        selectiveProcessId={selectiveProcessId}
        isLegacy={isLegacy}
        registrationData={registration}
        allowFilterVacancyTree={allowFilterVacancyTree}
      />
      {/* <CardRegistrationMoreDetail registrationId={registration?.registration_id} isOpen={isOpen} />
      <Divider my={2} color="gray.400" />
      <Flex gap={1} cursor="pointer" onClick={onToggle} justifyContent="center" alignItems="center">
        <Box transform={`rotate(${isOpen ? 180 : 0}deg)`} transition="transform 0.3s ease">
          <IoIosArrowDropdown />
        </Box>
        <Text>Mostrar {isOpen ? 'menos' : ''} detalhes</Text>
      </Flex> */}
    </Box>
  );
};

export default CardRegistrationMobilePage;
